import React from 'react';
import { Text, Title, Paper, Box, Loader, Stack, Tabs } from '@mantine/core';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useMLSettings } from '../../../hooks/useSettings';
import { IconCategory, IconBrain } from '@tabler/icons';
import { BusinessCategoriesTab } from './BusinessCategoriesTab';
import { PACModelConfigTab } from './PACModelConfigTab';

const MLSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'business-categories';

  const { data: mlSettings, isLoading } = useMLSettings();

  const handleTabChange = (value: string) => {
    // Update URL with new tab value
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('tab', value);
    navigate(`${location.pathname}?${newSearchParams.toString()}`);
  };

  if (isLoading) {
    return (
      <Box m="md">
        <Title order={2} mb="xl">ML Settings</Title>
        <Paper p="md">
          <Stack spacing="xl">
            <Loader />
          </Stack>
        </Paper>
      </Box>
    );
  }

  return (
    <Box m="md">
      <Title order={2} mb="xl">ML Settings</Title>
      <Paper withBorder>
        <Tabs value={activeTab} onTabChange={handleTabChange} styles={{
          tab: {
            padding: "12px 16px"
          }
        }}>
          <Tabs.List>
            <Tabs.Tab value="business-categories" icon={<IconCategory size={16} />}>Business Categories</Tabs.Tab>
            <Tabs.Tab value="mlpac-model-config" icon={<IconBrain size={16} />}>PACModelConfig</Tabs.Tab>
          </Tabs.List>

          <Box p="md">
            <Tabs.Panel value="business-categories">
              <BusinessCategoriesTab />
            </Tabs.Panel>
            
            <Tabs.Panel value="mlpac-model-config">
              <PACModelConfigTab />
            </Tabs.Panel>
          </Box>
        </Tabs>
      </Paper>
    </Box>
  );
};

export default MLSettings; 